import 'css-chunksrc/client/scenes/unavailabilityCreation/styles.scss';export default {
  "unavailabilityCreation": "_unavailabilityCreation_104en_1",
  "title": "_title_104en_9",
  "main": "_main_104en_15",
  "buttons": "_buttons_104en_28"
};